import { graphql } from '../gql';

export const getTodoTasksForVendors = graphql(`
  query GetTodoTasksForVendors($vendorIds:[ID!]!, $expiresAfter: ISO8601DateTime!) {
    getTodoTasksForVendors(
      input: {
        vendorIds: $vendorIds
        todoTaskStates: [incomplete]
        expiresAfter: $expiresAfter
      }
    ) {
      error {
        code
        message
        details {
          message
          codeAsString
        }
      }
      todoTasks {
        id
        action
        dueAt
        expiresAt
        ownerId
        ownerType
        state
        grouping
        workItems {
          __typename
          ... on PopupEventVendor {
            id
            vendor {
              internalName
            }
            popupEvent {
              id
              productType
              status
              eventStartTime
              eventEndTime
              account {
                name
              }
            }
            eventLocation {
              id
              serviceEndTime
              serviceStartTime
              setupTime
              stationType
              location {
                name
              }
            }
            location {
              id
              buildingAddressNotes
            }
          }
          ... on SchedulingAvailabilityRequirement {
            id
            vendor {
              id
              internalName
            }
            productType
            month
            year
          }
        }
      }
    }
  }
`);
